import { useFetch, usePortalConfig } from "@develos/next-library";

export const useStream = (streamUId: string|undefined) => {
    const { portalUrls } = usePortalConfig();

    const getStreamSource = () => {
        const portalApiUrl = portalUrls.portalApiUrl

        return {
            src: `${portalApiUrl}LiveCameraPreview/${streamUId}/index.m3u`,
            type: 'application/x-mpegURL'
        };
    }

    return {
        getStreamSource
    }
}